// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY: bookmark notes (favorites-bookmarks-plan.md sections 4 and 10), keyed by message id. Filled from the
// bookmarks list's pages and their reload on open and focus (BookmarkNoteReload.ts); a removed bookmark loses its
// note; READY empties it, as it does the list. "" and a missing entry both mean no note. Exclude from upstream sync.

import {ResettableStates} from '@app/features/app/state/ResettableStates';
import {makeAutoObservable, observable} from 'mobx';

class BookmarkNotes {
	private notes = observable.map<string, string>();

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	get(messageId: string): string {
		return this.notes.get(messageId) ?? '';
	}

	setFromEntries(entries: ReadonlyArray<{messageId: string; note: string}>): void {
		for (const {messageId, note} of entries) this.set(messageId, note);
	}

	set(messageId: string, note: string): void {
		if (note === '') this.notes.delete(messageId);
		else this.notes.set(messageId, note);
	}

	remove(messageId: string): void {
		this.notes.delete(messageId);
	}

	reset(): void {
		this.notes.clear();
	}
}

const bookmarkNotes = new BookmarkNotes();
ResettableStates.register(bookmarkNotes, bookmarkNotes.reset);
export default bookmarkNotes;
